import React from 'react';
import { motion } from 'framer-motion';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-sage/[0.08] px-5 py-12 sm:py-20" data-id="element-26" data-mp="185xjh68yb20v">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="13de6aae6e8wl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-28" data-mp="13ccw084zhqfx">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-29" data-mp="yfcn7pgr29l4">
            🎁 4 Professional Bonuses Included
          </h2>
          <p className="mt-3 text-sm text-slate/70 sm:text-base" data-id="element-30" data-mp="tdnb06hsjpvg">
            No extra cost. Included with your access today.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-31" data-mp="kg38ku86znj9">
          {bonos.map((bono, i) => <motion.article key={bono.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-sage/25 bg-white p-6 shadow-sm shadow-sage/5 sm:p-7" data-id="element-32" data-mp="fgqnadwyyois" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-33" data-mp="vvajzq7btpms">
                <span className="rounded-md bg-sage px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-34" data-mp="huzpmd6t5swv">
                  {bono.badge}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-35" data-mp="mvx70njzuixb">
                  {bono.icon}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold leading-snug text-slate sm:text-lg" data-id="element-36" data-mp="1elifbm4sbbsf">
                {bono.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate/70" data-id="element-37" data-mp="10t2k37i4ki22">
                {bono.description}
              </p>
              <div className="mt-5 flex items-center justify-between" data-id="element-38" data-mp="15qc76gi1khmq">
                <span className="text-sm text-slate/50 line-through" data-id="element-39" data-mp="1tgop8k703ur1">{bono.value}</span>
                <span className="rounded-full bg-sage px-3 py-1 text-xs font-bold text-white" data-id="element-40" data-mp="1y9ri0q3yf066">
                  INCLUDED TODAY
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}